import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-endereco',
  templateUrl: './text-numero-endereco.component.html',
  styleUrls: ['./text-numero-endereco.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroEnderecoComponent implements OnInit {
  
  constructor() {}

  ngOnInit() {}

}
